export { Flow } from './Flow'


import { BoundsHelper, Box, Group, UI, autoLayoutType, boundsType, Plugin, UIData } from '@leafer-ui/draw'

import '@leafer-in/resize'

import { flowX } from './layout/flowX'
import { flowY } from './layout/flowY'
import { autoBoundsType } from './decorate'


Plugin.add('flow', 'resize')


const box = Box.prototype, uiData = UIData.prototype, { __updateBoxBounds } = Group.prototype

// addAttr
UI.addAttr('flow', false, autoLayoutType)
UI.addAttr('gap', 0, boundsType)
UI.addAttr('flowAlign', 'top-left', boundsType)
UI.addAttr('flowWrap', false, boundsType)

UI.addAttr('itemBox', 'box', boundsType)
UI.addAttr('inFlow', true, boundsType)

UI.addAttr('autoWidth', undefined, autoBoundsType)
UI.addAttr('autoHeight', undefined, autoBoundsType)
UI.addAttr('autoBox', undefined, boundsType)


const { copyAndSpread, unsign } = BoundsHelper

box.__updateFlowLayout = function (): void {
    const { leaferIsCreated, flow } = this

    if (leaferIsCreated) this.leafer.created = false // 拦截布局更新通知，进行手动更新布局

    switch (flow) {
        case 'x':
        case true:
            flowX(this)
            break
        case 'y':
            flowY(this)
            break
        case 'x-reverse':
            flowX(this, true)
            break
        case 'y-reverse':
            flowY(this, true)
            break
    }

    if (leaferIsCreated) this.leafer.created = true
}

box.__updateContentBounds = function (): void {
    const { padding } = this.__
    const layout = this.__layout
    const same = layout.contentBounds === layout.boxBounds

    if (padding) {
        if (same) layout.shrinkContent()

        copyAndSpread(layout.contentBounds, layout.boxBounds, padding, true)
        unsign(layout.contentBounds) // fix: 防止产生负数宽高，导致排版异常

    } else {
        if (!same) layout.shrinkContentCancel()
    }
}

box.__updateBoxBounds = function (secondLayout?: boolean): void { // autoSide且自动布局时需要二次布局
    if (this.children.length && !this.__useSelfBox) {

        const data = this.__, { flow } = data

        if (data.__autoSide) {

            if (data.__hasSurface) this.__extraUpdate() // Box自身存在样式，需要额外更新

            flow && !secondLayout ? this.__updateRectBoxBounds() : __updateBoxBounds.call(this)

            const { boxBounds } = this.__layout

            if (!data.__autoSize) {
                if (data.__autoWidth) {
                    if (!flow) boxBounds.width += boxBounds.x, boxBounds.x = 0
                    boxBounds.height = data.height, boxBounds.y = 0
                } else {
                    if (!flow) boxBounds.height += boxBounds.y, boxBounds.y = 0
                    boxBounds.width = data.width, boxBounds.x = 0
                }
            }

            flow && secondLayout && data.padding && copyAndSpread(boxBounds, boxBounds, data.padding, false, data.__autoSize ? null : (data.__autoWidth ? 'width' : 'height'))

            this.__updateNaturalSize()

        } else {
            this.__updateRectBoxBounds()
        }

        if (flow) this.__updateContentBounds()

    } else {
        this.__updateRectBoxBounds()
    }
}

Object.defineProperty(uiData, '__autoWidth', {
    get(): boolean { return this._width == null && this._autoWidth == null }
})

Object.defineProperty(uiData, '__autoHeight', {
    get(): boolean { return this._height == null && this._autoHeight == null }
})

Object.defineProperty(uiData, '__autoSide', {
    get(): boolean { return this.__autoWidth || this.__autoHeight }
})

Object.defineProperty(uiData, '__autoSize', {
    get(): boolean { return this.__autoWidth && this.__autoHeight }
})